export type CertificationExpiryStatus =
  | "valid"
  | "expiring_soon"
  | "expired"
  | "unknown";

const EXPIRY_WARNING_DAYS = 30;

export function calculateCertificationExpiryStatus(
  expiryDate: Date | null | undefined
): CertificationExpiryStatus {
  if (!expiryDate) {
    return "unknown";
  }

  const now = new Date();
  const diffMs = expiryDate.getTime() - now.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  if (diffDays < 0) {
    return "expired";
  }
  if (diffDays <= EXPIRY_WARNING_DAYS) {
    return "expiring_soon";
  }
  return "valid";
}

export function formatCertificationExpiryStatus(
  status: CertificationExpiryStatus
): string {
  switch (status) {
    case "expired":
      return "expired";
    case "expiring_soon":
      return "expiring soon";
    case "unknown":
      return "unknown";
    default:
      return "valid";
  }
}

export function certificationStatusToBadgeVariant(
  status: CertificationExpiryStatus
): "secondary" | "warning" | "destructive" | "outline" {
  switch (status) {
    case "expired":
      return "destructive";
    case "expiring_soon":
      return "warning";
    case "unknown":
      return "outline";
    default:
      return "secondary";
  }
}
